/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {toAbsoluteUrl} from '../../../helpers'
import Swal from 'sweetalert2'
import { Languages } from './Languages'
import { Tr } from '../../../i18n/Tr'

const HeaderUserMenu: FC = () => {

  const t = Tr()
  var vendor:any=sessionStorage.getItem("vendor")
  vendor=JSON.parse(vendor)

  const confirmlogout=()=>{
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Sign Out'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {
       
        sessionStorage.removeItem("vendor");window.location.reload();
      } 
    });
  }
  
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-semibold py-4 fs-6 w-325px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='vendor avatar' src={vendor && vendor.profile_picture || toAbsoluteUrl('/media/avatars/300-9.jpg')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bold d-flex align-items-center fs-5'>
              {vendor?.fullName}
            </div>
            <div className='fw-semibold text-muted fs-7 text-break'>
              {vendor?.email}
            </div>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <Languages />
      <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          {t('Account Settings')}
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={()=>{confirmlogout()}} className='menu-link px-5'>
          {t('Sign Out')}
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
